import { render, staticRenderFns } from "./CompareData.vue?vue&type=template&id=34aafd6a&scoped=true"
import script from "./CompareData.vue?vue&type=script&lang=js"
export * from "./CompareData.vue?vue&type=script&lang=js"
import style0 from "./CompareData.scss?vue&type=style&index=0&id=34aafd6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aafd6a",
  null
  
)

export default component.exports